module.exports = __webpack_public_path__ + "img/magnifying-glass-white.7cc94736.svg";